<template>
    <modal @modal-close="handleClose">

        <div class="modal-wrapper">

            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <template v-if="!reachedFreePlanLimit">
                    <div class="item">
                        <h4>{{ $t("Title") }}</h4>
                        <p>{{ checklist.title }}</p>
                    </div>

                    <div class="item" v-if="checklist.description">
                        <h4>{{ $t("Description") }}</h4>
                        <p class="whitespace-pre-line">{{ checklist.description }}</p>
                    </div>

                    <div class="item">
                        <h4>{{ $t("Last downloaded at") }}</h4>
                        <p>{{ $du(checklist.checked_at, 'shortDateTime') }}</p>
                    </div>
                </template>

                <reached-inspection-limit-message v-else />

                <offline-inspection-message v-if="displayOfflineWarning" />
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        v-if="reachedFreePlanLimit"
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleClose"
                    >
                        {{ $t('Go back') }}
                    </button>
                    <button
                        v-else
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleStart"
                    >
                        {{ $t('Start Inspection') }}
                    </button>
                </div>
            </div>


        </div>

    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ReachedInspectionLimitMessage from '@mobile/components/ReachedInspectionLimitMessage';
import OfflineInspectionMessage from '@mobile/components/OfflineInspectionMessage';
import CloseButton from '@/components/Modals/CloseButton.vue';
import OnFreePlan from '@mobile/mixins/OnFreePlan';

export default {
    components: {
        OfflineInspectionMessage,
        ReachedInspectionLimitMessage,
        CloseButton,
    },

    mixins: [OnFreePlan],

    props: {
        checklist: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapGetters({
            online: 'connection/online',
        }),

        hasOneSite() {
            return Object.values(this.checklist.sites).length === 1;
        },

        hasMultipleSites() {
            return Object.values(this.checklist.sites).length > 1;
        },

        reachedFreePlanLimit() {
            return this.user.subscription.inspections && this.user.subscription.inspections.limit_reached;
        },

        displayOfflineWarning() {
            return !this.reachedFreePlanLimit && !this.online && this.isOnFreePlan;
        },
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleStart() {
            this.$emit('start');
        },
    },
};
</script>
